// extracted by mini-css-extract-plugin
export default {"logicTabDefault":"LogicTab_logicTabDefault__4p34E","textContent":"LogicTab_textContent__H9Fjx","text":"LogicTab_text__NDO2d","logicTabSelected":"LogicTab_logicTabSelected__ek28H"};